export default [
  {
    "inputs": [],
    "name": "BURNER",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "CASTER",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "CONFIGURER",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "CREATOR",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "DESTROYER",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "LIMITER",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "MAINTAINER",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "MINTER",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "NONE",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "ORACLE",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "RESERVED",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "SUPERUSER",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "TRANSFERER",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "role",
        "type": "uint8"
      }
    ],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "roleName",
        "type": "string"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "roleHash",
        "type": "bytes32"
      }
    ],
    "name": "roleForHash",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "role",
        "type": "uint8"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "roleName",
        "type": "string"
      }
    ],
    "name": "roleForName",
    "outputs": [
      {
        "internalType": "enum Roles.Role",
        "name": "role",
        "type": "uint8"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "roleName",
        "type": "string"
      }
    ],
    "name": "roleIndexForName",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "roleIndex",
        "type": "uint8"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  }
];